module.exports = __webpack_public_path__ + "static/media/question_circle.777d76d8.svg";